import { observer } from 'mobx-react-lite'
import { type ITextFieldWithLabelProps, TextFieldWithLabel } from 'shared/ui'
import { type ITextFieldProps } from 'shared/ui/TextField'
import styles from 'entities/Phone/ui/AssignNumberCommon/ui/NewInboxContent/styles.module.scss'
import { type NewInboxStore } from 'entities/Phone/ui/AssignNumberCommon/ui/NewInboxContent/store/newInboxStore'

type INewInboxNameProps = {
  newInboxStore: NewInboxStore
  textFieldProps?: Omit<ITextFieldProps, 'InputProps'>
} & Omit<ITextFieldWithLabelProps, 'errorMessage' | 'textFieldProps'>

export const NewInboxName = observer(
  ({ newInboxStore, textFieldProps, ...props }: INewInboxNameProps) => {
    const { newInboxName, hasNameError, setNewInboxName, validateName } = newInboxStore

    return (
      <TextFieldWithLabel
        limit={40}
        errorMessage={hasNameError ? 'The name must be at least 3 characters.' : undefined}
        textFieldProps={{
          onChange: setNewInboxName,
          value: newInboxName,
          onBlur: validateName,
          InputProps: {
            placeholder: 'Enter inbox name',
            className: styles.inboxNameInput,
          },
          ...textFieldProps,
        }}
        {...props}
      />
    )
  }
)
